import { createContext } from "react";

export const TallesContext = createContext()
export const TallesFormContext = createContext()
export const TallesReportContext = createContext()